export const QUILL_MODULES = {
  toolbar: [
    [{ 'header': [1, 2, 3, false] }],
    ['bold', 'italic'],
    [{ 'align': [] }],
    [{ 'list': 'ordered'}, { 'list': 'bullet' }],
    ['clean']                                         
  ],
  clipboard: {
    matchVisual: false
  }
};

export const QUILL_FORMATS = [
  'header',
  'bold', 'italic',
  'align',
  'list', 'bullet',
];